import { createRoot } from 'react-dom/client';
import 'core-js';
import App from './packages/app/src/App';
import { getFeatureFlagBeforeInit } from './packages/app/src/utils/getFeatureFlag';
import initSentry from './packages/app/src/utils/setupSentry';

// ChartJS register
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

// Better to init apps before rendering the app
const initApps = async () => {
  if (process.env.REACT_APP_ENVIRONMENT !== 'DEVELOPMENT') {
    const isForeignDataTrackingDisabled = await getFeatureFlagBeforeInit(
      'isForeignDataTrackingDisabled',
    );

    // US BASED
    if (!isForeignDataTrackingDisabled) {
      initSentry();
    }
  }
};

initApps();

// Please avoid adding any extra code here, put it in `MainProvider` or a better fit location
createRoot(document.getElementById('root')!).render(<App />);
